import { WButton } from "@/components/button/WButton.tsx";
import { WCheckbox } from "@/components/forms/WCheckbox.tsx";
import { configAtom } from "@/config.ts";
import { auth0ConfigAtom } from "@/modules/login/auth0/auth0Config.ts";
import { LoginBox, LoginLayout } from "@/modules/login/LoginLayout.tsx";
import { Trans } from "@lingui/react/macro";
import { useAtomValue } from "jotai";
import { useMemo, useState } from "react";
import invariant from "tiny-invariant";

export function ConsentForm() {
    //#region Hooks
    const { domain: auth0Domain } = useAtomValue(auth0ConfigAtom);
    const {
        termsUrl: { url, url_text },
    } = useAtomValue(configAtom);

    const [accepted, setAccepted] = useState(false);
    //#endregion

    // XXX: We ignore this since it's incompatible with translation
    void url_text;
    invariant(url, "Terms URL must be configured");

    const search = document.location.search;
    const redirectUrl = useMemo(() => {
        const state = new URLSearchParams(search).get("state");
        invariant(state, "State query parameter is required");

        // Reference: https://auth0.com/docs/customize/actions/explore-triggers/signup-and-login-triggers/login-trigger/redirect-with-actions#resume-the-authentication-flow
        const redirectUrl = new URL(`https://${auth0Domain}/continue`);
        redirectUrl.searchParams.set("state", state);
        return redirectUrl.toString();
    }, [search, auth0Domain]);

    const content = (
        <form method="post" action={accepted ? redirectUrl : "#"} className="my-4 flex flex-col gap-4">
            <input type="hidden" name="confirm" value="yes" />
            <p>
                <Trans>To use our services, you need to agree to the Terms of Service.</Trans>
            </p>
            <div className="flex items-center gap-2">
                <WCheckbox value={accepted ? "checked" : ""} onChange={setAccepted} />
                <span>
                    <Trans>
                        I have read and agree to the{" "}
                        <a className="text-blue underline" href={url} target="_blank" rel="noopener noreferrer">
                            Terms of Service
                        </a>
                    </Trans>
                </span>
            </div>
            <WButton type="submit" color="primary" action={undefined} isDisabled={!accepted}>
                <Trans>Continue</Trans>
            </WButton>
        </form>
    );

    return (
        <LoginLayout>
            <LoginBox title={<Trans>Terms of Service</Trans>}>{content}</LoginBox>
        </LoginLayout>
    );
}
